<template>
  <div id="areamanage">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "areamanage"
};
</script>

<style scoped>
</style>